import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import StackSquareIcon from '../../../components/Icons/StackSquareIcon';
import PageLayout from '../../../components/Layout/PageLayout';
import { Modal } from '../../../components/Modal/Modal';
import ReportInformationModal from '../../../components/Modal/ModalActions/ReportInformationModal/ReportInformationModal';
import Page from '../../../components/Page/Page';
import Table from '../../../components/Table/Table';
import ActionRow from '../../../components/Table/TableAccessories/ActionRow';
import useGetDriverReportAndConflictDetails from '../../../hooks/dashboard/companyInsight/useGetDriverReportAndConflictDetails';
import {
  PERFORMANCE_MONITORING,
  PERFORMANCE_MONITORING_SEARCH_RESULTS,
  PERFORMANCE_MONITORING_SEARCH_RESULTS_CONFLICT_DETAILS,
} from '../../../routes/routeConstants';
import DriverBioArea from './DriverBioArea';

const PerformanceMonitoringSearchResults = () => {
  const navigate = useNavigate();
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);
  const { nin } = useParams();

  const {
    getDriverReportAndConflictDetails,
    loading,
    showSuccessModal,
    setShowSuccessModal,
    driverReportAndConflictDetailsData,
  } = useGetDriverReportAndConflictDetails();

  const handleRowActionCall = async (data: any) => {
    await getDriverReportAndConflictDetails(data);
  };

  if (driverReportAndConflictDetailsData) {
    navigate(`/${PERFORMANCE_MONITORING_SEARCH_RESULTS_CONFLICT_DETAILS}`);
  }

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Performance Monitoring`,
        link: `/${PERFORMANCE_MONITORING}`,
      },
      {
        name: `Results for NIN: ${nin}`,
        link: `/${PERFORMANCE_MONITORING_SEARCH_RESULTS}/${nin}`,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Driver Information'>
      <PageLayout>
        <BreadCrumbs pathData={pathArr as any} />
        <Container>
          <HeaderArea>
            <DriverBioArea />
          </HeaderArea>

          <Table
            // border
            tableTitle='DRIVER LIST'
            tableFilterBoxFeatures={{
              showSearchBox: true,
              searchBoxPlaceholder: 'Search Driver Name',
            }}
            tableHeader={{
              'Company Name': 'username',
              'Employment type': 'username',
              'Time at Company': 'username',
              'Employment Status': 'username',
              'Hiring Conflicts': 'phoneNumber',
              'Accident Reports': 'email',
              'Theft Reports': 'email',
            }}
            tableDataSourceUrl='authentication-service/ba/v1/company/users/warehouse'
            cellsCustomComp={{}}
            moreOptionsComponents={[
              <ActionRow
                key='View details'
                label='View details'
                width='174px'
                icon={!loading ? <StackSquareIcon /> : <StackSquareIcon />}
                actionFn={async (data: any) => {
                  handleRowActionCall(data);
                }}
              />,
            ]}
            // mobileCellComp={<UserProfileManagementCell />}
            // showPaginationControl={false}
          />
        </Container>

        <Modal showModal={showSuccessModal} setShowModal={setShowSuccessModal}>
          <ReportInformationModal
            label='Report Information'
            description='There are currently no hiring conflicts, accident reports, or theft
        reports associated with this record.'
          />
        </Modal>
      </PageLayout>
    </Page>
  );
};

export default PerformanceMonitoringSearchResults;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const HeaderArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 28px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};
`;
